import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import styles from "./RadioButton.module.scss";

const RadioButton = forwardRef(function RadioButton(
  { id, name, checked, defaultChecked, value, disabled, onChange, label, className, ...rest },
  ref
) {
  return (
    <div className={cx(styles.RadioButton, className)}>
      <input
        type="radio"
        id={id}
        name={name}
        value={value}
        checked={checked}
        defaultChecked={defaultChecked}
        disabled={disabled}
        onChange={onChange}
        ref={ref}
        {...rest}
      />
      <label htmlFor={id}>{label}</label>
    </div>
  );
});

RadioButton.displayName = "RadioButton";

RadioButton.defaultProps = {
  id: undefined,
  checked: undefined,
  defaultChecked: undefined,
  value: undefined,
  name: undefined,
  disabled: false,
  onChange: undefined,
  label: null,
  className: undefined
};

RadioButton.propTypes = {
  id: PropTypes.string,
  checked: PropTypes.bool,
  defaultChecked: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
  name: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  label: PropTypes.node,
  className: PropTypes.string
};

export default RadioButton;
